// @flow

// force flow to type check this file - https://github.com/zapier/zapier/pull/31127
import React from 'react'; /* eslint-disable-line no-unused-vars */

import { jsx } from '@emotion/core';
import { type BannerType, Tag } from '@zapier/common-components';

/** @jsx jsx */

type Props = {
  banner?: ?BannerType,
};

const bannerColors = {
  beta: 'viper',
  'by-invite': 'steel',
  deprecated: 'steel',
  premium: 'oldManLogan',
  upcoming: 'armor',
};

const AppBanner = ({ banner }: Props) => {
  if (!banner) {
    return null;
  }

  return (
    <Tag backgroundColor={bannerColors[banner]}>
      {banner.replace(/-/g, ' ')}
    </Tag>
  );
};

export default AppBanner;
